@switch (state()) {
  @case ('ENTER_PIN') {
    <rrp-pin-pad
      #pinPad
      [titleTranslateKey]="getTitleKey()"
      [errorTranslateKey]="errorKey()"
      [showBiometric]="false"
      [showLogout]="false"
      (pinEntered)="onPinEntered($event)"
    />
  }

  @case ('CONFIRM_PIN') {
    <div class="pin-setup">
      <button class="pin-setup__back" (click)="onBack()" type="button">
        <lib-svg-icon size="24" icon="arrow-left" />
      </button>

      <rrp-pin-pad
        #pinPad
        [titleTranslateKey]="getTitleKey()"
        [errorTranslateKey]="errorKey()"
        [showBiometric]="false"
        [showLogout]="false"
        (pinEntered)="onPinEntered($event)"
      />
    </div>
  }

  @case ('BIOMETRIC') {
    <div class="biometric-setup">
      <div class="biometric-setup__logo">
        <img
          ngSrc="assets/images/pool-logo.svg"
          alt="logo"
          priority="high"
          width="150"
          height="75"
        />
      </div>

      <div class="biometric-setup__content">
        <div class="biometric-setup__icon">
          <lib-svg-icon size="80" icon="fingerprint" />
        </div>

        <h2 class="biometric-setup__title">
          {{ 'pin.biometric.setup-title' | translate }}
        </h2>

        <p class="biometric-setup__description">
          {{
            'pin.biometric.setup-description'
              | translate: { type: (biometryTypeName() | translate) }
          }}
        </p>

        @if (errorKey(); as error) {
          <p class="biometric-setup__error">
            {{ error | translate }}
          </p>
        }

        <div class="biometric-setup__actions">
          <button
            class="biometric-setup__btn biometric-setup__btn--primary"
            (click)="onEnableBiometric()"
            [disabled]="isLoading()"
            type="button"
          >
            @if (isLoading()) {
              {{ 'pin.biometric.loading' | translate }}
            } @else {
              {{ 'pin.biometric.enable' | translate }}
            }
          </button>

          <button
            class="biometric-setup__btn biometric-setup__btn--secondary"
            (click)="onSkipBiometric()"
            [disabled]="isLoading()"
            type="button"
          >
            {{ 'pin.biometric.skip' | translate }}
          </button>
        </div>
      </div>
    </div>
  }
}
